<script context="module">
  import { get_three_previous_months, auffuellen } from "./Utils.svelte";
  import { is_country_checked } from "./UtilsBalkenProgress.svelte";

  export function create_list_of_sources(data) {
    let list_of_sources = [];

    data.forEach((element) => {
      if (element["source"]) {
        if (!list_of_sources.includes(element["source"])) {
          list_of_sources.push(element["source"]);
        }
      }
    });

    return list_of_sources;
  }

  export function seperate_per_month(data, column) {
    var date_dict = []; // create an empty array
    var date_dict = []; // create an empty array

    let initial = get_three_previous_months();

    let count = 0;
    initial.forEach((element) => {
      date_dict[element] = 0;
    });

    // console.log('date_dict: ', date_dict);

    data.forEach((element) => {
      count = count + 1;
      if (element[column]) {
        date_dict[element[column].substring(0, 7)] = [];
      }
    });

    // console.log("count: ", count)

    data.forEach((element) => {
      if (element[column]) {
        date_dict[element[column].substring(0, 7)].push(element);
      }
    });

    return date_dict;
  }

  export function current_sales_to_target(data) {
    let target_sum = 0;
    let current_sum = 0;

    data.forEach((element) => {
      target_sum = target_sum + element["target_goal"];
      current_sum = current_sum + element["current"];
    });

    if (current_sum < target_sum) {
      return {
        labels: ["current: " + current_sum.toString(), "remaining: " + (target_sum - current_sum).toString()],
        datasets: [current_sum, target_sum - current_sum],
      };
    } else {
      return {
        labels: ["current: " + current_sum.toString(), "over target: " + (current_sum - target_sum).toString()],
        datasets: [current_sum, target_sum - current_sum],
      };
    }
  }

  export function create_res_partner_data_from_all(data, button_extension = "") {
    let lead_since_data = [];
    var today = new Date();

    data.forEach((element) => {
      if (element["sales"] < 0.1) {
        return;
      }

      // var create_date_obj = new Date(element['create_date']);
      // let diffTime = Math.abs(today - create_date_obj);
      // let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      lead_since_data.push({
        // days_since: diffDays.toString(),
        name: element["name"].toString().replace('"', "").replace("'", "").replace('"', "").replace("'", ""),
        // company: element['company_id'].toString(),
        herdsize: auffuellen(element["x_studio_herdengre_1"]),
        create_date: element["create_date"] ? element["create_date"].substring(0, 10) : "",
        first_order_date: element["first_order_date"] ? element["first_order_date"].toString() : "",
        sales: auffuellen(element["sales"].toFixed(2)),
        currency: element["currency"],
        button: "<button class='table_button" + button_extension + " btn' " + "id='res_" + element["id"] + "'" + ">select</button>",
      });
    });

    return lead_since_data;
  }

  export function merge_index(keys, goals_keys) {
    return keys.concat(goals_keys.filter((item) => keys.indexOf(item) < 0));
  }

  export function create_goals_list_for_sold_list(goals_input, keys, year_filter) {
    let goals_dict = {};
    let keys_list = [];

    // console.log('goals_input: ', goals_input);

    let goals = [];

    goals_input.forEach(function (element) {
      let e = {};
      Object.assign(e, element);
      goals.push(e);
    });

    let goals_dict_sum = {};
    goals.forEach(function (element) {
      if (element["start_date"]) {
        // if(element['start_date'].substring(0,7) == "2022-03"){
        //   console.log("märz: ", element['target_goal'])
        // }
      } else {
        return;
      }

      if (!goals_dict_sum[element["start_date"].substring(0, 7)]) {
        // if(element['start_date'].substring(0,7) == "2022-03"){
        //   console.log("erstes vorkommen")
        // }

        goals_dict_sum[element["start_date"].substring(0, 7)] = element["target_goal"];
      } else {
        // sum of goals:
        goals_dict_sum[element["start_date"].substring(0, 7)] =
          goals_dict_sum[element["start_date"].substring(0, 7)] + element["target_goal"];
      }
    });

    /////////////////////////

    goals.forEach(function (element) {
      // console.log("element goal: ", element)
      // goals_dict[element['start_date'].substring(0, 7)] = element['target_goal'];
      if (element["start_date"]) {
        if (element["start_date"].substring(0, 4) == year_filter || year_filter == "ALL") {
          keys_list.push(element["start_date"].substring(0, 7));
          // console.log("key push: ", element['start_date'].substring(0, 7))
        }
      }
    });

    let alle_keys = keys.sort(); // die zukünftigen fehlen noch

    // console.log("alle_keys: ", alle_keys)
    // console.log("hey: ", alle_keys[alle_keys.length - 1])

    keys_list.sort().forEach(function (k) {
      // console.log("compare " + k + " with " + alle_keys[alle_keys.length - 1] + " is " + k.localeCompare(alle_keys[alle_keys.length - 1]).toString())
      if (k.localeCompare(alle_keys[alle_keys.length - 1]) > 0 || alle_keys.length == 0) {
        // console.log("alle keys push: ", k)
        alle_keys.push(k);
      }
    });

    let values_list = [];
    alle_keys.forEach(function (k) {
      values_list.push(goals_dict_sum[k]);
    });

    return { value: values_list, keys: alle_keys };
  }

  export function calculate_open_opportunities_per_month(opportunities_filtered, lost_opportunities_filtered, year_filter) {
    let ret_dict = {};
    let ret_dict_all = {};

    //status gewonnen nicht zählen bzw nur bis zu dem Monat wo gewonnen

    //Offen ab: date_conversion
    //Geschlossen:
    // . wenn status won (date_last_stage_update)
    // . wenn date_closed

    // für alle monate vom ältesten date_conversion bis heute

    opportunities_filtered.forEach(function (element) {
      var current_month_array = get_open_month_indexes_for_opportunity(element, year_filter);
      var current_all_month_array = get_all_month_indexes_for_opportunity(element, year_filter);

      current_month_array.forEach(function (m) {
        if (!ret_dict.hasOwnProperty(m)) {
          ret_dict[m] = 1;
        } else {
          ret_dict[m] = ret_dict[m] + 1;
        }
      });

      current_all_month_array.forEach(function (m) {
        if (!ret_dict_all.hasOwnProperty(m)) {
          ret_dict_all[m] = 1;
        } else {
          ret_dict_all[m] = ret_dict_all[m] + 1;
        }
      });
    });

    let month_keys = Object.keys(ret_dict);

    let keys_list = [];
    let values_list = [];

    month_keys.sort().forEach(function (m) {
      keys_list.push(m);
      values_list.push(ret_dict[m]);
    });

    month_keys = Object.keys(ret_dict_all);

    let keys_list_all = [];
    let values_list_all = [];

    month_keys.sort().forEach(function (m) {
      keys_list_all.push(m);
      values_list_all.push(ret_dict_all[m]);
    });

    return { values: values_list, keys: keys_list, values_all: values_list_all, keys_all: keys_list_all };
  }

  function get_open_month_indexes_for_opportunity(opportunity, year_filter) {
    let start_date_obj;
    let end_date_obj = false;

    if (opportunity["date_conversion"]) {
      start_date_obj = new Date(opportunity["date_conversion"]);
    } else {
      start_date_obj = new Date(opportunity["create_date"]);
    }

    if (opportunity["stage_id"]) {
      if (opportunity["stage_id"][1] == "Gewonnen") {
        end_date_obj = new Date(opportunity["date_last_stage_update"]);
      }
    }
    if (opportunity["date_closed"]) {
      end_date_obj = new Date(opportunity["date_closed"]);
    }

    if (!end_date_obj) {
      end_date_obj = new Date();
    }

    start_date_obj.setDate(1);
    end_date_obj.setDate(1);

    start_date_obj.setHours(0);
    start_date_obj.setMinutes(0);
    start_date_obj.setSeconds(0);

    end_date_obj.setHours(0);
    end_date_obj.setMinutes(0);
    end_date_obj.setSeconds(0);

    if (start_date_obj < new Date(1990, 1, 1)) {
      console.log("FRÜHER: ", start_date_obj);
      console.log("opportunity: ", opportunity);
    }

    let list_of_indexes = [];

    //    console.log("start_date_obj: ", start_date_obj)
    // console.log("end_date_obj: ", end_date_obj)

    while (start_date_obj <= end_date_obj) {
      let current_month_index;
      if (start_date_obj.getMonth() + 1 < 10) {
        current_month_index = start_date_obj.getFullYear().toString() + "-0" + (start_date_obj.getMonth() + 1).toString();
      } else {
        current_month_index = start_date_obj.getFullYear().toString() + "-" + (start_date_obj.getMonth() + 1).toString();
      }
      if (year_filter == "ALL" || year_filter == current_month_index.substring(0, 4)) {
        list_of_indexes.push(current_month_index);
      }
      start_date_obj.setMonth(start_date_obj.getMonth() + 1);
    }

    return list_of_indexes;
  }

  function get_all_month_indexes_for_opportunity(opportunity, year_filter) {
    let start_date_obj;
    let end_date_obj = new Date();

    if (opportunity["date_conversion"]) {
      start_date_obj = new Date(opportunity["date_conversion"]);
    } else {
      start_date_obj = new Date(opportunity["create_date"]);
    }

    start_date_obj.setDate(1);
    end_date_obj.setDate(1);

    start_date_obj.setHours(0);
    start_date_obj.setMinutes(0);
    start_date_obj.setSeconds(0);

    end_date_obj.setHours(0);
    end_date_obj.setMinutes(0);
    end_date_obj.setSeconds(0);

    let list_of_indexes = [];

    while (start_date_obj <= end_date_obj) {
      let current_month_index;
      if (start_date_obj.getMonth() + 1 < 10) {
        current_month_index = start_date_obj.getFullYear().toString() + "-0" + (start_date_obj.getMonth() + 1).toString();
      } else {
        current_month_index = start_date_obj.getFullYear().toString() + "-" + (start_date_obj.getMonth() + 1).toString();
      }
      if (year_filter == "ALL" || year_filter == current_month_index.substring(0, 4)) {
        list_of_indexes.push(current_month_index);
      }
      start_date_obj.setMonth(start_date_obj.getMonth() + 1);
    }

    return list_of_indexes;
  }

  export function calc_activiti_cat_dict_generic(
    mail_activity_all,
    mail_activity_all_filtered,
    date_column,
    only_done = false,
    won_status = false,
  ) {
    let month_list = [];
    let type_names = [];

    // console.log("mail_activity_all: ", mail_activity_all)

    mail_activity_all.forEach(function (element) {
      if (element[1]["mail_activity_type_id"]) {
        if (type_names.includes(element[1]["mail_activity_type_id"][1])) {
        } else {
          type_names.push(element[1]["mail_activity_type_id"][1]);
        }
      }
    });

    mail_activity_all_filtered.forEach(function (element) {
      if (!element[date_column]) {
        return;
      }

      if (only_done) {
        if (!element["date"]) {
          return;
        }
      }

      if (element["lead_type"] != "opportunity") {
        return;
      }

      if (!month_list.includes(element[date_column].substring(0, 7))) {
        month_list.push(element[date_column].substring(0, 7));
      }
    });

    month_list = month_list.sort();

    let values_dict = {};
    let kein_closed_date = 0;
    let gewonnen_sum = 0;
    let keine_opp = 0;
    let not_won = 0;
    let not_lost = 0;

    month_list.forEach(function (month) {
      values_dict[month] = {};
      type_names.forEach(function (t) {
        values_dict[month][t] = 0;
      });
    });

    mail_activity_all_filtered.forEach(function (element) {
      if (!element[date_column]) {
        return;
      }

      if (!element["mail_activity_type_id"]) {
        return;
      }

      if (only_done) {
        if (!element["date"]) {
          kein_closed_date += 1;
          return;
        }
      }

      if (won_status) {
        if (won_status == "won") {
          if (!element["stage_id"] || element["stage_id"][1] != "Gewonnen") {
            not_won += 1;
            // console.log("element: ", element)
            return;
          } else {
            // console.log("won: ", element)
          }
        }

        if (won_status == "lost") {
          if (!element["date_closed"]) {
            not_lost += 1;
            return;
          }
        }
      }

      if (element["lead_type"] != "opportunity") {
        keine_opp += 1;
        return;
      }

      // if(won_status == "won"){
      //   console.log("element: ", element)
      // }

      gewonnen_sum += 1;

      let month_index = element[date_column].substring(0, 7);
      let t = element["mail_activity_type_id"][1];

      values_dict[month_index][t] = values_dict[month_index][t] + 1;
    });

    let list_of_values_list = [];

    type_names.forEach(function (element) {
      list_of_values_list.push([]);
    });

    month_list.forEach(function (m) {
      type_names.forEach(function (t) {
        let index = type_names.indexOf(t);
        list_of_values_list[index].push(values_dict[m][t]);
      });
    });

    // console.log("type_names: ", type_names)

    return { keys: month_list, values: list_of_values_list, type_names: type_names };
  }

  export function calc_activiti_cat_dict(mail_activity_all_filtered) {
    let month_list = [];
    let type_names = [];

    mail_activity_all_filtered.forEach(function (element) {
      // console.log("element: ", element)
      // console.log("element['create_date'].substring(0,7): ", element['create_date'].substring(0,7))
      // console.log("month_list: ", month_list)
      if (month_list.includes(element["create_date"].substring(0, 7))) {
        // console.log("schon drinnen")
      } else {
        // console.log("einfügen")
        month_list.push(element["create_date"].substring(0, 7));
      }

      if (type_names.includes(element["activity_type__name"])) {
      } else {
        type_names.push(element["activity_type__name"]);
      }
    });

    month_list = month_list.sort();

    let values_dict = {};

    month_list.forEach(function (month) {
      values_dict[month] = {};
      type_names.forEach(function (t) {
        values_dict[month][t] = 0;
      });
    });

    mail_activity_all_filtered.forEach(function (element) {
      let month_index = element["create_date"].substring(0, 7);
      let t = element["activity_type__name"];

      values_dict[month_index][t] = values_dict[month_index][t] + 1;
    });

    let list_of_values_list = [];

    type_names.forEach(function (element) {
      list_of_values_list.push([]);
    });

    month_list.forEach(function (m) {
      type_names.forEach(function (t) {
        let index = type_names.indexOf(t);
        list_of_values_list[index].push(values_dict[m][t]);
      });
    });

    // console.log('list_of_values_list: ', list_of_values_list);
    // console.log('values_dict: ', values_dict);

    // console.log('month_list: ', month_list);
    // console.log('type_names: ', type_names);

    return { keys: month_list, values: list_of_values_list, type_names: type_names };
  }

  function isPositiveInteger(str) {
    if (typeof str !== "string") {
      return false;
    }

    const num = Number(str);

    if (Number.isInteger(num) && num > 0) {
      return true;
    }

    return false;
  }

  function add_star_if_top_three(s) {
    if (Number.isInteger(s)) {
      if (s > 0 && s < 4) {
        return s.toString() + " &#11088";
      } else {
        return s.toString();
      }
    } else {
      return s;
    }
  }

  export function lead_link(text, id) {
    return (
      "<a" +
      ' target="_blank" ' +
      'href="https://smaxtec.odoo.com/web#id=' +
      id.toString() +
      '&action=897&model=crm.lead&view_type=form&cids=1%2C2%2C3%2C4&menu_id=121">' +
      text.toString() +
      "</a>"
    );
  }

  function partner_link(text, id) {
    return (
      "<a" +
      ' target="_blank" ' +
      'href="https://smaxtec.odoo.com/web#id=' +
      id.toString() +
      '&model=res.partner&view_type=form&cids=1%2C2%2C3%2C4&menu_id=121">' +
      text.toString() +
      "</a>"
    );
  }

  export function calculate_powerchart_over_year_ranks(data, salesman, year) {
    let ranks = {};
    let numbers = {};
    let salesman_index = 0;

    // console.log("######", data)

    let important_values = [
      "classic_boli_sold", //
      "ph_boli_sold", //
      "new_customers", //
      "First Visit Potential Customer", //
      "Cold Visit",
      "Follow-Up Visit Potential Customer", //
      "Existing Customer Visit", //
      "Call", //
      "To Do", //
      "Installation",
    ];

    data.forEach(function (element) {
      numbers[salesman[salesman_index]] = {
        classic_boli_sold: 0,
        ph_boli_sold: 0,
        new_customers: 0,
        "First Visit Potential Customer": 0,
        "Cold Visit": 0,
        "Follow-Up Visit Potential Customer": 0,
        "Existing Customer Visit": 0,
        Call: 0,
        "To Do": 0,
        Installation: 0,
      };

      ranks[salesman[salesman_index]] = {
        classic_boli_sold: 0,
        ph_boli_sold: 0,
        new_customers: 0,
        "First Visit Potential Customer": 0,
        "Cold Visit": 0,
        "Follow-Up Visit Potential Customer": 0,
        "Existing Customer Visit": 0,
        Call: 0,
        "To Do": 0,
        Installation: 0,
      };

      salesman_index = salesman_index + 1;
    });

    salesman_index = 0;

    data.forEach(function (months) {
      for (const [monthkey, m_data] of Object.entries(months)) {
        if (monthkey.substring(0, 4) == year) {
          for (const [key, value] of Object.entries(m_data)) {
            if (important_values.includes(key)) {
              numbers[salesman[salesman_index]][key] = numbers[salesman[salesman_index]][key] + value;
            } else {
              // console.log("key: ", key)
              // console.log("m_data: ", m_data)
            }
          }
        }
      }
      salesman_index = salesman_index + 1;
    });

    // console.log("numbers: ", numbers)

    // Ranks berechnen:
    for (const [salesmanname, n] of Object.entries(numbers)) {
      important_values.forEach(function (valkey) {
        var meins = n[valkey];
        var rank = 1;

        for (const [salesmanname, n] of Object.entries(numbers)) {
          if (n[valkey] > meins) {
            rank = rank + 1;
          }
        }

        ranks[salesmanname][valkey] = rank;
      });
    }

    // console.log("ranks: ", ranks)

    let powerchart_dict = {};

    // console.log("year: ", year)

    var x = 0;
    while (x < salesman.length) {
      var i = 0;
      var powerchart_line = [];
      if (salesman[x] != "Others") {
        while (i < important_values.length) {
          powerchart_line.push(numbers[salesman[x]][important_values[i]]);
          powerchart_line.push(ranks[salesman[x]][important_values[i]]);
          i = i + 1;
        }
        powerchart_dict[salesman[x]] = powerchart_line;
      }
      x = x + 1;
    }

    // console.log("powerchart_dict: ", powerchart_dict)

    return { ranks: ranks, pcline: powerchart_dict };
  }

  export function create_power_chart_table(data, this_year, year_filter) {
    let retdata = [];

    let for_ranks = [];

    for (let element in data) {
      // var create_date_obj = new Date(element['create_date']);
      // let diffTime = Math.abs(today - create_date_obj);
      // let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      // console.log("element: ", element)

      if (year_filter == "ALL" || element.substring(0, 4) == year_filter.toString()) {
        // console.log("element.substring(0,4): ", element.substring(0,4))
        for_ranks.push({
          year_month: element,
          classic_boli_sold: data[element]["classic_boli_sold"],
          classic_boli_sold_ranking: data[element]["classic_boli_sold_ranking"],
          ph_boli_sold: data[element]["ph_boli_sold"],
          ph_boli_sold_ranking: data[element]["ph_boli_sold_ranking"],
          new_customers_won: data[element]["new_customers"],
          new_customers_won_ranking: data[element]["new_customers_ranking"],
          first_visit: data[element]["First Visit Potential Customer"],
          first_visit_ranking: data[element]["First Visit Potential Customer_ranking"],
          cold_visit: data[element]["Cold Visit"],
          cold_visit_ranking: data[element]["Cold Visit_ranking"],
          follow_up: data[element]["Follow-Up Visit Potential Customer"],
          follow_up_ranking: data[element]["Follow-Up Visit Potential Customer_ranking"],
          customer_visit: data[element]["Existing Customer Visit"],
          customer_visit_ranking: data[element]["Existing Customer Visit_ranking"],
          calls: data[element]["Call"],
          calls_ranking: data[element]["Call_ranking"],
          todos: data[element]["To Do"],
          todos_ranking: data[element]["To Do_ranking"],
          installation: data[element]["Installation"],
          installation_ranking: data[element]["Installation_ranking"],
        });
      }
    }

    for (let element in data) {
      // var create_date_obj = new Date(element['create_date']);
      // let diffTime = Math.abs(today - create_date_obj);
      // let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (element.substring(0, 4) == year_filter.toString() || year_filter == "ALL") {
        retdata.push({
          year_month: element,
          classic_boli_sold: data[element]["classic_boli_sold"],
          classic_boli_sold_ranking: "<b>" + add_star_if_top_three(data[element]["classic_boli_sold_ranking"]) + "</b>",
          ph_boli_sold: data[element]["ph_boli_sold"],
          ph_boli_sold_ranking: "<b>" + add_star_if_top_three(data[element]["ph_boli_sold_ranking"]) + "</b>",
          new_customers_won: data[element]["new_customers"],
          new_customers_won_ranking: "<b>" + add_star_if_top_three(data[element]["new_customers_ranking"]) + "</b>",
          first_visit: data[element]["First Visit Potential Customer"],
          first_visit_ranking: "<b>" + add_star_if_top_three(data[element]["First Visit Potential Customer_ranking"]) + "</b>",
          cold_visit: data[element]["Cold Visit"],
          cold_visit_ranking: "<b>" + add_star_if_top_three(data[element]["Cold Visit_ranking"]) + "</b>",
          follow_up: data[element]["Follow-Up Visit Potential Customer"],
          follow_up_ranking: "<b>" + add_star_if_top_three(data[element]["Follow-Up Visit Potential Customer_ranking"]) + "</b>",
          customer_visit: data[element]["Existing Customer Visit"],
          customer_visit_ranking: "<b>" + add_star_if_top_three(data[element]["Existing Customer Visit_ranking"]) + "</b>",
          calls: data[element]["Call"],
          calls_ranking: "<b>" + add_star_if_top_three(data[element]["Call_ranking"]) + "</b>",
          todos: data[element]["To Do"],
          todos_ranking: "<b>" + add_star_if_top_three(data[element]["To Do_ranking"]) + "</b>",

          installation: data[element]["Installation"],
          installation_ranking: "<b>" + add_star_if_top_three(data[element]["Installation_ranking"]) + "</b>",
        });
      }
    }

    var year_name = new Date().getFullYear().toString();
    if (year_filter != "ALL") {
      year_name = year_filter.toString();
    }

    retdata.push({
      year_month: "<b>" + year_name + "</b>",
      classic_boli_sold: this_year[0],
      classic_boli_sold_ranking: this_year[1],
      ph_boli_sold: this_year[2],
      ph_boli_sold_ranking: this_year[3],
      new_customers_won: this_year[4],
      new_customers_won_ranking: this_year[5],
      first_visit: this_year[6],
      first_visit_ranking: this_year[7],
      cold_visit: this_year[8],
      cold_visit_ranking: this_year[9],
      follow_up: this_year[10],
      follow_up_ranking: this_year[11],
      customer_visit: this_year[12],
      customer_visit_ranking: this_year[13],
      calls: this_year[14],
      calls_ranking: this_year[15],
      todos: this_year[16],
      todos_ranking: this_year[17],
      installation: this_year[18],
      installation_ranking: this_year[19],
    });

    let ranks_tmp = for_ranks.at(-1);

    // console.log('ranks_tmp: ', ranks_tmp);

    let rank = [
      ranks_tmp["calls_ranking"],
      ranks_tmp["classic_boli_sold_ranking"],
      ranks_tmp["customer_visit_ranking"],
      ranks_tmp["first_visit_ranking"],
      ranks_tmp["cold_visit_ranking"],
      ranks_tmp["follow_up_ranking"],
      ranks_tmp["new_customers_won_ranking"],
      ranks_tmp["ph_boli_sold_ranking"],
      ranks_tmp["todos_ranking"],
      ranks_tmp["installation_ranking"],
    ];
    // console.log('rank: ', rank);

    let rank_changed = [];

    rank.forEach(function (element) {
      if (Number.isInteger(element)) {
        rank_changed.push(element);
      } else {
        rank_changed.push(10000);
      }
    });

    return { chart: retdata.reverse(), rank: rank_changed };
  }

  export function calc_opportunities_chart(new_data, won_data, lost_data, year_filter) {
    let dict = {};

    new_data.forEach(function (element) {
      let date = element["date_conversion"];

      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }
        date = date.substring(0, 7);
        dict[date] = { new: 0, won: 0, lost: 0 };
      }
      date = element["date_last_stage_update"];
      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }
        date = date.substring(0, 7);
        dict[date] = { new: 0, won: 0, lost: 0 };
      }
    });

    won_data.forEach(function (element) {
      let date = element["date_last_stage_update"];

      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }
        date = date.substring(0, 7);
        dict[date] = { new: 0, won: 0, lost: 0 };
      }
    });

    lost_data.forEach(function (element) {
      let date = element["x_date_closed"];

      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }

        date = date.substring(0, 7);
        dict[date] = { new: 0, won: 0, lost: 0 };
      }
    });

    new_data.forEach(function (element) {
      let date = element["date_conversion"];

      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }

        date = date.substring(0, 7);
        dict[date]["new"] = dict[date]["new"] + 1;
      } else {
        date = element["create_date"];
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }
        if (dict[date] === undefined) {
          date = date.substring(0, 7);
          dict[date] = { new: 0, won: 0, lost: 0 };
        }
        if (date) {
          date = date.substring(0, 7);
          dict[date]["new"] = dict[date]["new"] + 1;
        }
      }
    });

    won_data.forEach(function (element) {
      let date = element["date_last_stage_update"];

      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }
        date = date.substring(0, 7);
        dict[date]["won"] = dict[date]["won"] + 1;
        if (date == "2023-10") {
          // console.log("won opp: ", element)
        }
      } else {
        date = element["write_date"];

        if (date) {
          if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
            console.log("date: ", date);
            return;
          }
          date = date.substring(0, 7);
          dict[date]["won"] = dict[date]["won"] + 1;
          // console.log("won opp: ", element)
        }
      }
    });

    let debug_lost_list = [];

    lost_data.forEach(function (element) {
      let date = element["x_date_closed"];

      if (date) {
        if (year_filter != "ALL" && year_filter != date.substring(0, 4)) {
          return;
        }
        date = date.substring(0, 7);

        if (date.substring(0, 7) == "2022-02") {
          debug_lost_list.push(element);
          // console.log("lost element: ", element)
        }

        dict[date]["lost"] = dict[date]["lost"] + 1;
      }
    });

    let months = Object.keys(dict);

    let new_list = [];
    let won_list = [];
    let lost_list = [];

    // console.log('months.sort(): ', months.sort());

    months.sort().forEach(function (m) {
      new_list.push(dict[m]["new"]);
      won_list.push(dict[m]["won"]);
      lost_list.push(dict[m]["lost"]);
    });

    return { keys: months.sort(), values: [new_list, won_list, lost_list] };
  }

  export function calc_converted(data, year_filter) {
    let ret_dict = {};

    data.forEach(function (element) {
      if (element["date_conversion"]) {
        let year = element["date_conversion"].substring(0, 4);
        if (year_filter == "ALL" || year_filter.toString() == year) {
          let year_month = element["date_conversion"].substring(0, 7);

          if (year_month in ret_dict) {
            ret_dict[year_month] = ret_dict[year_month] + 1;
          } else {
            ret_dict[year_month] = 1;
          }
        }
      } else {
        let year = element["create_date"].substring(0, 4);
        if (year_filter == "ALL" || year_filter.toString() == year) {
          if (element["create_date"]) {
            let year_month = element["create_date"].substring(0, 7);

            if (year_month in ret_dict) {
              ret_dict[year_month] = ret_dict[year_month] + 1;
            } else {
              ret_dict[year_month] = 1;
            }
          }
        }
      }
    });

    let list_months = [];
    let list_values = [];

    let month_keys = Object.keys(ret_dict).sort();

    month_keys.forEach(function (month) {
      list_months.push(month);
      list_values.push(ret_dict[month]);
    });

    return { keys: list_months, values: list_values };
  }

  export function count_opportunities_without_activity(data, year_filter) {
    let count = 0;

    let without_activity_list = [];

    data.forEach(function (element) {
      if (!element["__has_activity"] && element["stage_id"][0] != 5) {
        // console.log("ohne aktivität: ", element)

        var year;

        if (element["date_conversion"]) {
          year = element["date_conversion"].substring(0, 4);
        } else {
          if (element["create_date"]) {
            year = element["create_date"].substring(0, 4);
          }
        }

        if (year) {
          if (year_filter != "ALL") {
            if (year_filter.toString() != year) {
              return;
            }
          }
        }

        if (element["source_id"]) {
          if (element["source_id"][1] == "Data Import") {
            return;
          }
        }

        if (element["stage_id"][1] != "Closing" && element["stage_id"][1] != "Gewonnen") {
          if (!element["lost_reason"]) {
            count = count + 1;

            // console.log("without activity: ", element)

            without_activity_list.push(element);
            // console.log('push');
          }
        }
      }
    });

    // console.log('without_activity_list: ', without_activity_list);

    return { count: count, without_activity_list: without_activity_list };
  }

  export function count_opportunities_with_overdue_activity(data, year_filter) {
    let count = 0;

    let with_overdue_activity_list = [];

    data.forEach(function (element) {
      if (element["__overdue_activity"]) {
        // console.log("ohne aktivität: ", element)

        var year;

        if (element["date_conversion"]) {
          year = element["date_conversion"].substring(0, 4);
        } else {
          if (element["create_date"]) {
            year = element["create_date"].substring(0, 4);
          }
        }

        if (year) {
          if (year_filter != "ALL") {
            if (year_filter.toString() != year) {
              return;
            }
          }
        }

        if (element["source_id"]) {
          if (element["source_id"][1] == "Data Import") {
            return;
          }
        }

        if (element["stage_id"][1] != "Closing" && element["stage_id"][1] != "Gewonnen") {
          if (!element["lost_reason"]) {
            count = count + 1;

            // console.log("without activity: ", element)

            with_overdue_activity_list.push(element);
            // console.log('push');
          }
        }
      } else {
        // console.log('mit aktivität: ', element);
      }
    });

    // console.log('without_activity_list: ', without_activity_list);

    return { count: count, with_overdue_activity_list: with_overdue_activity_list };
  }

  export function calculate_cancelled_subscriptions(data, year) {
    let values_dict = {};
    let end_date_obj;
    let start_date_obj;

    if (year == "ALL") {
      end_date_obj = new Date();
      start_date_obj = new Date(2020, 5, 1);
    } else {
      // console.log('year: ', year);
      // console.log('parseInt(year): ', parseInt(year));
      end_date_obj = new Date(parseInt(year), 11, 1);
      start_date_obj = new Date(parseInt(year), 0, 1);
    }

    // console.log('end_date_obj: ', end_date_obj);
    // console.log('start_date_obj: ', start_date_obj);

    start_date_obj.setDate(1);
    end_date_obj.setDate(1);

    start_date_obj.setHours(0);
    start_date_obj.setMinutes(0);
    start_date_obj.setSeconds(0);

    end_date_obj.setHours(0);
    end_date_obj.setMinutes(0);
    end_date_obj.setSeconds(0);

    let list_of_indexes = [];

    //    console.log("start_date_obj: ", start_date_obj)
    // console.log("end_date_obj: ", end_date_obj)

    while (start_date_obj <= end_date_obj) {
      let current_month_index;
      if (start_date_obj.getMonth() + 1 < 10) {
        current_month_index = start_date_obj.getFullYear().toString() + "-0" + (start_date_obj.getMonth() + 1).toString();
      } else {
        current_month_index = start_date_obj.getFullYear().toString() + "-" + (start_date_obj.getMonth() + 1).toString();
      }

      list_of_indexes.push(current_month_index);
      start_date_obj.setMonth(start_date_obj.getMonth() + 1);
    }

    list_of_indexes.forEach(function (element) {
      values_dict[element] = 0;
    });

    // console.log('list_of_indexes: ', list_of_indexes);

    data.forEach(function (element) {
      // console.log("cancelled element: ", element)

      if (element["order_type"]) {
        if (
          element["order_type"] == "Warranty" ||
          element["order_type"] == "Goodwill" ||
          element["order_type"] == "Referral" ||
          element["order_type"] == "Warranty / Goodwill" ||
          element["order_type"] == "goodwill" ||
          element["order_type"] == "referral"
        ) {
          return;
        }
      }

      if (element["close_reason_id"]) {
        if (element["close_reason_id"][1] == "Canceled") {
          if (element["date"]) {
            let month_index = element["date"].substring(0, 7);

            if (month_index in values_dict) {
              values_dict[month_index] = values_dict[month_index] + 1;
            } else {
              values_dict[month_index] = 1;
            }
          }
        }
      }
    });

    // console.log('values_dict: ', values_dict);

    let keys = Object.keys(values_dict).sort();
    let values = [];

    keys.forEach(function (k) {
      values.push(values_dict[k]);
    });

    return { keys: keys, values: values };
  }

  export function count_opportunities_wit_abschluss_past(data) {
    let count = 0;

    let list = [];

    var today = new Date();

    data.forEach(function (element) {
      if (element["date_deadline"]) {
        if (element["date_deadline"].toString().length > 8) {
          var date_deadline_obj = new Date(element["date_deadline"]);
          if (today > date_deadline_obj) {
            if (element["stage_id"][0] != 5) {
              if (element["active"]) {
                count = count + 1;
                list.push(element);
              }
            }
          }
        }
      }
    });

    return { count: count, list: list };
  }

  function stage_data_to_real_name(stage) {
    if (stage == "Closing") {
      return "Closing";
    }
    return stage;
  }

  export function create_table_data_opportunities(data) {
    let ret_list = [];

    data.forEach(function (element) {
      if (!element["partner_id"]) {
        return;
      }

      ret_list.push({
        lead_link: lead_link(element["name"], element["id"]),
        partner: partner_link(element["partner_id"][1], element["partner_id"][0]),
        create_date: element["create_date"],
        stage: stage_data_to_real_name(element["stage_id"][1]),
      });
    });

    return { data: ret_list, columns: ["Partner", "Created", "Last Stage Update", "First Order"] };
  }

  export function create_prediction(indexe_merged, sale_order_filtered, laender_dict = false) {
    let weighted_list = [];
    let unweighted_list = [];
    let today_str_month_index;

    if (new Date().getMonth() + 1 < 10) {
      today_str_month_index = new Date().getFullYear().toString() + "-0" + (new Date().getMonth() + 1).toString();
    } else {
      today_str_month_index = new Date().getFullYear().toString() + "-" + (new Date().getMonth() + 1).toString();
    }

    indexe_merged.forEach(function (element) {
      if (element.localeCompare(today_str_month_index) >= 0) {
      } else {
        unweighted_list.push(undefined);
        weighted_list.push(undefined);
      }
    });

    let erwarteter_abschluss_dict_weighted = {};
    let erwarteter_abschluss_dict_unweighted = {};

    let month_liste = [];

    var today = new Date();
    var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    sale_order_filtered.forEach(function (val) {
      var element = 1 in val ? val[1] : val;

      let datum = element["date_deadline"];
      if (!datum) {
        return;
      }

      let datum_obj = new Date(datum);

      if (today > datum_obj) {
        return;
      }

      if (laender_dict) {
        if (!is_country_checked(laender_dict, element["country"])) {
          return;
        }
      }

      let month_index = datum.substring(0, 7);
      let boly_qty = element["boly_qty"];
      let probability = element["probability"];
      let boly_count_prob = Math.ceil((boly_qty * probability) / 100);

      if (!indexe_merged.includes(month_index)) {
        return;
      }

      if (!month_liste.includes(month_index)) {
        month_liste.push(month_index);
      }

      if (!erwarteter_abschluss_dict_weighted.hasOwnProperty(month_index)) {
        erwarteter_abschluss_dict_weighted[month_index] = boly_count_prob;
      } else {
        erwarteter_abschluss_dict_weighted[month_index] = erwarteter_abschluss_dict_weighted[month_index] + boly_count_prob;
      }
      if (!erwarteter_abschluss_dict_unweighted.hasOwnProperty(month_index)) {
        erwarteter_abschluss_dict_unweighted[month_index] = boly_qty;
      } else {
        erwarteter_abschluss_dict_unweighted[month_index] = erwarteter_abschluss_dict_unweighted[month_index] + boly_qty;
      }

      // console.log('element: ', element);
    });

    // console.log("month_liste: ", month_liste)
    // console.log("erwarteter_abschluss_dict_unweighted: ", erwarteter_abschluss_dict_unweighted)

    month_liste.forEach(function (element) {
      if (erwarteter_abschluss_dict_weighted.hasOwnProperty(element)) {
        weighted_list.push(erwarteter_abschluss_dict_weighted[element]);
      } else {
        weighted_list.push(0);
      }

      if (erwarteter_abschluss_dict_unweighted.hasOwnProperty(element)) {
        unweighted_list.push(erwarteter_abschluss_dict_unweighted[element]);
      } else {
        unweighted_list.push(0);
      }
    });

    return { weighted: weighted_list, unweighted: unweighted_list };
  }

  export function count_leas_older_three_days(data) {
    //TODO ohne datenimport
    let now = Date.now();
    let count = 0;

    let values = [];

    data.forEach(function (element) {
      if (element["create_date"]) {
        let source = element["source_id"];
        // console.log("source: ", source)
        let doit = false;
        if (!source) {
          doit = true;
        } else {
          if (element["source_id"][1] != "Data Import" || true) {
            doit = true;
          } else {
            // console.log("source ist datenimport: ", element)
          }
        }

        if (doit) {
          let date = new Date(element["create_date"]);
          // console.log("date: ", date)
          let days_difference = (new Date().getTime() - date.getTime()) / (1000 * 3600 * 24);
          if (days_difference > 3) {
            count = count + 1;

            values.push({
              lead_link: lead_link(element["name"], element["id"]),
              source: element["source_id"] ? element["source_id"][1] : "",
              create_date: element["create_date"],
            });
          }
        }
      }
    });

    return { count: count, values: values, columns: ["Name", "Created"] };
  }

  export function create_leads_tabelle(data) {
    let values = [];

    data.forEach(function (element) {
      values.push({
        lead_link: lead_link(element["name"], element["id"]),
        source_id: element["source_id"] ? element["source_id"][1] : "",
        create_date: element["create_date"],
      });
    });

    return { values: values, columns: ["Name", "Source", "Created"] };
  }

  export function calculate_herd_coverage(data) {
    let active_animals_sum = 0;
    let herdsize_sum = 0;

    data.forEach(function (element) {
      if (element["active_animals"]) {
        active_animals_sum = active_animals_sum + element["active_animals"];
        herdsize_sum = herdsize_sum + element["x_studio_herdengre_1"];
      }
    });

    // console.log('active_animals_sum: ', active_animals_sum);
    // console.log('herdsize_sum: ', herdsize_sum);

    return {
      labels: ["active animals", "not covered"],
      datasets: [active_animals_sum, herdsize_sum - active_animals_sum],
    };
  }

  export function filter_partner(data, id, column_name, index) {
    let retlist = [];

    data.forEach(function (element) {
      if (element[column_name]) {
        if (index > -1) {
          if (element[column_name][index] == id) {
            retlist.push(element);
          }
        } else {
          if (element[column_name] == id) {
            retlist.push(element);
          }
        }
      }
    });
    return retlist;
  }

  export function accounts_highlights_left_corner(data) {
    //Hier gehts weiter
    let last_seven_days_count = 0;
    let last_month_count = 0;

    let last_seven_days_count_before = 0;
    let last_month_count_before = 0;

    let top_lead_finder_seven_days = {};
    let top_lead_finder_month = {};

    let top_lead_finder_seven_days_to_return = "-";
    let top_lead_finder_month_to_return = "-";

    let max = 10;

    data.forEach((element) => {
      if (element["date"] && max) {
        max = max - 1;
      }

      if (element["leadFinder"]) {
        top_lead_finder_seven_days[element["leadFinder"][1]] = 0;
        top_lead_finder_month[element["leadFinder"][1]] = 0;
      }
    });

    var today = new Date();
    data.forEach((element) => {
      var create_date_obj = new Date(element["date"]);
      let diffTime = Math.abs(today - create_date_obj);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays <= 7) {
        last_seven_days_count = last_seven_days_count + element["amount_total"];
      }
      if (diffDays <= 31) {
        last_month_count = last_month_count + element["amount_total"];
      }
      if (diffDays > 7 && diffDays <= 14) {
        last_seven_days_count_before = last_seven_days_count_before + element["amount_total"];
      }
      if (diffDays > 31 && diffDays <= 62) {
        last_month_count_before = last_month_count_before + element["amount_total"];
      }

      if (element["leadFinder"]) {
        if (diffDays <= 7) {
          top_lead_finder_seven_days[element["leadFinder"][1]] =
            top_lead_finder_seven_days[element["leadFinder"][1]] + element["amount_total"];
        }
        if (diffDays <= 31) {
          top_lead_finder_month[element["leadFinder"][1]] = top_lead_finder_month[element["leadFinder"][1]] + element["amount_total"];
        }
      }
    });

    var top_lead_finder_seven_days_array = Object.keys(top_lead_finder_seven_days).map(function (key) {
      return [key, top_lead_finder_seven_days[key]];
    });
    top_lead_finder_seven_days_array.sort(function (first, second) {
      return second[1] - first[1];
    });
    var top_lead_finder_month_array = Object.keys(top_lead_finder_month).map(function (key) {
      return [key, top_lead_finder_month[key]];
    });
    top_lead_finder_month_array.sort(function (first, second) {
      return second[1] - first[1];
    });

    if (top_lead_finder_seven_days_array.length > 0) {
      top_lead_finder_seven_days_to_return = top_lead_finder_seven_days_array[0][0];
    }
    if (top_lead_finder_month_array.length > 0) {
      top_lead_finder_month_to_return = top_lead_finder_month_array[0][0];
    }

    let last_seven_days_count_percentage =
      100 * Math.abs((last_seven_days_count_before - last_seven_days_count) / ((last_seven_days_count_before + last_seven_days_count) / 2));

    let last_month_count_percentage =
      100 * Math.abs((last_month_count_before - last_month_count) / ((last_month_count_before + last_month_count) / 2));

    let return_dict = {
      last_seven_days_count: last_seven_days_count.toFixed(2),
      last_month_count: last_month_count.toFixed(2),
      last_seven_days_percentage_vorzeichen: last_seven_days_count_before > last_seven_days_count ? false : true,
      last_month_vorzeichen: last_month_count_before > last_month_count ? false : true,
      top_lead_finder_seven_days: top_lead_finder_seven_days_to_return,
      top_lead_finder_month: top_lead_finder_month_to_return,
      last_seven_days_count_percentage: last_seven_days_count_percentage.toFixed(2),
      last_seven_days_count_before: last_seven_days_count_before,
      last_month_count_percentage: last_month_count_percentage.toFixed(2),
    };

    return return_dict;
  }

  export function add_res_partner_to_leads(lead_all_data_original_filtered, res_partners_all_data_original_filtered) {
    var res_partner_dict = to_dict(res_partners_all_data_original_filtered, "id");

    var copy = lead_all_data_original_filtered;

    lead_all_data_original_filtered.forEach(function (element, index, theArray) {
      if (element["partner_id"]) {
        theArray[index]["partner"] = res_partner_dict[element["partner_id"][0]];
        if (!theArray[index]["partner"]) {
          // console.log("theArray[index]: ", theArray[index])
          // console.log("res_partner_dict: ", res_partner_dict)
        }
      }
    });

    // lead_all_data_original_filtered.forEach((element) => {
    //   if (element['partner_id']) {
    //     element['partner'] = res_partner_dict[element['partner_id'][0]]
    //   }
    // });

    return lead_all_data_original_filtered;
  }

  export function to_dict(data, column) {
    var my_dict = {};

    data.forEach((element) => {
      if (element[column]) {
        my_dict[element[column]] = element;
      }
    });

    return my_dict;
  }

  export function create_bar_chart_dataset(column_names, values, title = "") {
    return {
      labels: column_names,
      datasets: [
        {
          label: title,
          data: values,
          backgroundColor: [
            "rgba(255, 134,159,0.4)",
            "rgba(98,  182, 239,0.4)",
            "rgba(255, 218, 128,0.4)",
            "rgba(113, 205, 205,0.4)",
            "rgba(170, 128, 252,0.4)",
            "rgba(255, 177, 101,0.4)",
          ],
          borderWidth: 2,
          borderColor: [
            "rgba(255, 134, 159, 1)",
            "rgba(98,  182, 239, 1)",
            "rgba(255, 218, 128, 1)",
            "rgba(113, 205, 205, 1)",
            "rgba(170, 128, 252, 1)",
            "rgba(255, 177, 101, 1)",
          ],
        },
      ],
    };
  }

  export function calc_new_customers_over_size(lead_data) {
    let histo_data_column_labels = ["0", "1-100", "100-200", "200-500", "500-1000", ">1000"];
    let histo_data = [0, 0, 0, 0, 0, 0, 0];
    // 0-100, 100-200, 200-500, 500-1000

    lead_data.forEach((element) => {
      // if (element['id'] == 314476) {
      //   console.log('element selected: ', element);
      // }

      if (element["stage_id"][1] == "Gewonnen") {
        // console.log("element von herdengre: ", element)
        if (!element["partner"]) {
          return;
        }
        var herdengr = element["partner"]["x_studio_herdengre"];

        // if (!herdengr) {
        //   return;
        // }

        if (herdengr == 0) {
          histo_data[0] = histo_data[0] + 1;
        }
        if (herdengr > 0 && herdengr <= 100) {
          histo_data[1] = histo_data[1] + 1;
        }
        if (herdengr > 100 && herdengr <= 200) {
          histo_data[2] = histo_data[2] + 1;
        }
        if (herdengr > 200 && herdengr <= 500) {
          histo_data[3] = histo_data[3] + 1;
        }
        if (herdengr > 500 && herdengr <= 1000) {
          histo_data[4] = histo_data[4] + 1;
        }
        if (herdengr > 1000) {
          histo_data[5] = histo_data[5] + 1;
        }
      }
    });

    return {
      columns: histo_data_column_labels,
      data: histo_data,
    };
  }
</script>
